import styled, { css } from 'styled-components';
import { Link, LinkProps } from 'react-router-dom';
import { fadeAndSlideInUp, loadingOverlay } from '../../../core/styles';
import { mapper } from '../../../utils/styles';
import { darken } from 'polished';

export const AccountPanelLogo = styled.div`
  width: 150px;
  height: 69px;
  margin: 0 auto 20px;
  background: url('data:image/svg+xml;base64,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');
  background-size: cover;
  animation: ${fadeAndSlideInUp} 0.3s ease-out;
`;

export const AccountPanelTitle = styled.h1`
  margin-bottom: 25px;
  text-align: center;
  font-size: 28px;
`;

export const AccountPanelDescription = styled.div`
  margin-bottom: 25px;
  text-align: center;
`;

export const AccountPanelError = styled.div`
  margin-bottom: 20px;
  color: ${props => props.theme.brandAlert};
`;

interface AccountPanelLinkProps extends LinkProps {
  isCreateUser?: boolean;
}

export const AccountPanelLink = styled(Link)<AccountPanelLinkProps>`
  font-weight: ${props => props.theme.fontWeightMedium};
  font-size: 12px;
  ${props =>
    props.isCreateUser &&
    css`
      text-decoration: underline;
      color: rgb(0, 157, 144);
    `};
`;

export const CreateUserLink = styled.div`
  text-align: center;
`;

export const CreateUserPanel = styled.div`
  margin-top: 20px;
`;

interface AccountPanelProps {
  size?: string;
  isLoading?: boolean;
}

export const AccountPanel = styled.div<AccountPanelProps>`
  width: ${props => mapper(props.size, { small: '320px', medium: '400px' })};
  margin-top: -100px;
  animation: ${fadeAndSlideInUp} 0.3s ease-out;

  ${props =>
    props.isLoading &&
    css`
      ${props => loadingOverlay('24px', props.theme.bodyBackgroundColor)};
    `};
`;

export const AccountPage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
`;

export const ClickMe = styled.a`
  margin: 0px 5px;
  text-align: center;
  color: ${props => props.theme.brandPrimary};
  &:hover {
    color: ${props => darken(0.05, props.theme.brandPrimary)};
    cursor: pointer;
  }
`;
